module.exports = __webpack_public_path__ + "static/media/01.47dcc928.jpg";